module.exports = __webpack_public_path__ + "static/media/circo2024_fitas_aereas.9b745b3a.webp";